export interface CourseInfo {
  id: string
  title: string
  description: string
  status: 'active' | 'locked' | 'coming-soon'
  moduleCount: number
  lessonCount: number
  progress?: number
  modules: Array<{
    title: string
    lessonCount: number
  }>
}

export const coursesData: CourseInfo[] = [
  {
    id: 'concept-clc',
    title: 'Training 1 — Concept CLC',
    description:
      'Înțelegerea conceptului Cautlocuință.ro, a structurii agenției și a ecosistemului profesional.',
    status: 'active',
    moduleCount: 2,
    lessonCount: 6,
    progress: 0,
    modules: [
      {
        title: 'Modul 1 — Introducere în Conceptul CLC',
        lessonCount: 3,
      },
      {
        title: 'Modul 2 — Structura și Cultura CLC',
        lessonCount: 3,
      },
    ],
  },
  {
    id: 'proceduri-inchiriere',
    title: 'Training 2 — Proceduri și Tranzacții Închiriere',
    description:
      'Procedurile complete pentru activitatea de închiriere: prospectare, clienți, matching, contracte și închidere.',
    status: 'active',
    moduleCount: 6,
    lessonCount: 15,
    progress: 0,
    modules: [
      {
        title: 'Modul 1 — Client Proprietar',
        lessonCount: 5,
      },
      {
        title: 'Modul 2 — Client Chiriaș',
        lessonCount: 2,
      },
      {
        title: 'Modul 3 — Matching',
        lessonCount: 2,
      },
      {
        title: 'Modul 4 — Contracte',
        lessonCount: 2,
      },
      {
        title: 'Modul 5 — Vizionare',
        lessonCount: 2,
      },
      {
        title: 'Modul 6 — Închidere Tranzacție & Contabilitate',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'proceduri-vanzare',
    title: 'Training 3 — Proceduri și Tranzacții Vânzare',
    description:
      'Procesul complet de vânzare: de la prospectare până la semnare la notariat și închiderea tranzacției.',
    status: 'locked',
    moduleCount: 7,
    lessonCount: 22,
    modules: [
      {
        title: 'Modul 1 — Prospectare Vânzare',
        lessonCount: 4,
      },
      {
        title: 'Modul 2 — Client Cumpărător',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Matching Vânzare',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Evaluare și Negociere',
        lessonCount: 4,
      },
      {
        title: 'Modul 5 — Verificare Acte și Legalitate',
        lessonCount: 3,
      },
      {
        title: 'Modul 6 — Notariat și Semnare',
        lessonCount: 3,
      },
      {
        title: 'Modul 7 — Închidere și Facturare Vânzare',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'marketing-promovare',
    title: 'Training 4 — Marketing și Promovare',
    description:
      'Strategii de marketing digital, promovare proprietăți și generare de leaduri.',
    status: 'locked',
    moduleCount: 4,
    lessonCount: 14,
    modules: [
      {
        title: 'Modul 1 — Fundamente Marketing Imobiliar',
        lessonCount: 4,
      },
      {
        title: 'Modul 2 — Social Media și Conținut',
        lessonCount: 4,
      },
      {
        title: 'Modul 3 — Campanii Plătite',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Generare și Calificare Leaduri',
        lessonCount: 3,
      },
    ],
  },
  {
    id: 'negociere-avansata',
    title: 'Training 5 — Negociere Avansată',
    description:
      'Tehnici avansate de negociere pentru tranzacții complexe și clienți premium.',
    status: 'locked',
    moduleCount: 5,
    lessonCount: 16,
    modules: [
      {
        title: 'Modul 1 — Psihologia Negocierii',
        lessonCount: 4,
      },
      {
        title: 'Modul 2 — Strategii de Negociere',
        lessonCount: 4,
      },
      {
        title: 'Modul 3 — Gestionarea Obiecțiilor',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Negociere Tranzacții Premium',
        lessonCount: 3,
      },
      {
        title: 'Modul 5 — Closing Avansat',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'legal-fiscal',
    title: 'Training 6 — Legal și Fiscal',
    description:
      'Aspecte juridice, fiscale și contractuale în tranzacțiile imobiliare.',
    status: 'locked',
    moduleCount: 6,
    lessonCount: 18,
    modules: [
      {
        title: 'Modul 1 — Legislație Imobiliară',
        lessonCount: 4,
      },
      {
        title: 'Modul 2 — Contracte și Clauze',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Verificare Acte',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Aspecte Fiscale',
        lessonCount: 3,
      },
      {
        title: 'Modul 5 — Situații Speciale',
        lessonCount: 3,
      },
      {
        title: 'Modul 6 — Protecție și Prevenție',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'management-portofoliu',
    title: 'Training 7 — Management Portofoliu',
    description:
      'Gestionarea eficientă a portofoliului de proprietăți și clienți.',
    status: 'locked',
    moduleCount: 4,
    lessonCount: 12,
    modules: [
      {
        title: 'Modul 1 — Organizare Portofoliu',
        lessonCount: 3,
      },
      {
        title: 'Modul 2 — CRM și Automatizare',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Follow-up și Retenție',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Optimizare Performanță',
        lessonCount: 3,
      },
    ],
  },
  {
    id: 'segmente-specializate',
    title: 'Training 8 — Segmente Specializate',
    description:
      'Tranzacții specializate: terenuri, spații comerciale, investiții B2B.',
    status: 'locked',
    moduleCount: 5,
    lessonCount: 15,
    modules: [
      {
        title: 'Modul 1 — Tranzacții Terenuri',
        lessonCount: 4,
      },
      {
        title: 'Modul 2 — Spații Comerciale',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Investiții B2B',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Dezvoltări Imobiliare',
        lessonCount: 3,
      },
      {
        title: 'Modul 5 — Consultanță Investiții',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'leadership-management',
    title: 'Training 9 — Leadership și Management',
    description:
      'Dezvoltare personală, leadership și coordonare echipă pentru Selling Masters.',
    status: 'locked',
    moduleCount: 5,
    lessonCount: 14,
    modules: [
      {
        title: 'Modul 1 — Leadership Imobiliar',
        lessonCount: 3,
      },
      {
        title: 'Modul 2 — Management Echipă',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Mentorat și Training',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Dezvoltare Personală',
        lessonCount: 3,
      },
      {
        title: 'Modul 5 — Scaling Business',
        lessonCount: 2,
      },
    ],
  },
  {
    id: 'strategie-cariera',
    title: 'Training 10 — Strategie și Carieră',
    description:
      'Planificare strategică, dezvoltare pe termen lung și construirea brandului personal.',
    status: 'locked',
    moduleCount: 4,
    lessonCount: 12,
    modules: [
      {
        title: 'Modul 1 — Planificare Strategică',
        lessonCount: 3,
      },
      {
        title: 'Modul 2 — Brand Personal',
        lessonCount: 3,
      },
      {
        title: 'Modul 3 — Networking și Parteneriate',
        lessonCount: 3,
      },
      {
        title: 'Modul 4 — Carieră pe Termen Lung',
        lessonCount: 3,
      },
    ],
  },
]
